import React, { Component } from "react";
import styles from "./input.module.css";
import TextField from "@material-ui/core/TextField";
import classnames from "classnames";
import { debounce } from "lodash";
// import { isValidTextNames } from "src/utils/field-validation";
import renderHTML from "html-react-parser";
import { _t } from "src/redux/store";

type Props = {
  classname?: string;
  name: string;
  value: string;
  label: string;
  info?: string;
  handleOnChange: Function;
};

type State = {
  value: string;
  input: {
    isValid: boolean;
    warning: string;
  };
};

class Input extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: props.value || "",
      input: {
        isValid: true,
        warning: "",
      },
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.value !== this.state.value) {
      this.debouncedHandleOnChange();
    }
    if (!!this.props.value && prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value || ""
      });
    }
  }

  // debouncedHandleOnChange = debounce(() => {
  //   this.validateInput(this.state.value);
  //   if (this.state.input.isValid) {
  //     this.props.handleOnChange(this.props.name, this.state.value);
  //   } else {
  //     this.props.handleOnChange(this.props.name, "");
  //   }
  // }, 500);

  debouncedHandleOnChange = debounce(() => {
    this.validateInput(this.state.value);
    this.props.handleOnChange(this.props.name, this.state.value, this.state.input.isValid);
  }, 500);

  handleOnChange = (newValue: string) => {
    this.setState({ value: newValue || "" });
  };

  validateInput = (text: string) => {
    if (text.length > 2) {
      // const isValid = isValidTextNames(text);

      this.setState({
        input: {
          isValid: true,
          warning: _t.translate("Invalid text."),
        },
      });
    } else {
      this.setState({
        input: {
          isValid: false,
          warning: _t.translate("Text too small."),
        },
      });
    }
  };

  render() {
    return (
      <div
        className={classnames(
          styles.formControl,
          typeof this.props.classname !== "undefined" && this.props.classname
        )}
      >
        <span className={styles.label}>{this.props.label}</span>
        <label className={styles.inputWrapper}>
          <TextField
            className={classnames(
              styles.textField,
              !this.state.input.isValid && styles.error
            )}
            onChange={(e) => this.handleOnChange(e.target.value)}
            value={this.state.value}
            InputProps={{
              className: styles.input,
              disableUnderline: true,
            }}
          />
        </label>
        {typeof this.props.info !== "undefined" && (
          <div className={styles.info}>{renderHTML(this.props.info)}</div>
        )}
        {!this.state.input.isValid && (
          <small className={styles.warning}>{this.state.input.warning}</small>
        )}
      </div>
    );
  }
}

export default Input;
